import type { MediaFormFields } from "~/MediaLibrary/types/mediaLibraryFormTypes";
import { sendEvent } from "./ga";

const filtersAliases = {
  mediaTypes: "Media Type",
  productPortfolios: "Product Category",
  languages: "Language",
  segments: "Sector",
  fetchFavourite: "Favorites Toggle",
  q: "Query",
  sortOrder: "Sort by",
};

export function trackMediaLibraryFilterActions(query: string | undefined, section: keyof MediaFormFields, name = "") {
  if (name == "" && section == undefined && query == "") {
    sendEvent({
      event: "Media_Library_Interaction",
      action: "Filters Cleared",
      raw_action: "Click",
      query: query || undefined,
    });

    return;
  } else {
    let data = {
      event: "Media_Library_Interaction",
      action: section == "sortOrder" ? "Sort Applied" : "Filter Applied",
      raw_action: "Click",
      name,
      query: query || undefined,
    };

    if (section != "sortOrder") {
      sendEvent({
        ...data,
        section: filtersAliases[section],
      });
      return;
    }
    sendEvent(data);
  }
}

export function trackSearchSubmitted(query: string, results: number) {
  if (query == "") return;
  sendEvent({
    event: "Media_Library_Interaction",
    action: "Search Submitted",
    raw_action: "Submit",
    query,
    results,
  });
}

export function trackAssetInteraction(action: string, id: string, name?: string, language?: string, type?: string) {
  sendEvent({
    event: "Media_Library_Interaction",
    action,
    raw_action: "Click",
    name,
    id,
    language,
    type,
  });
}

export function trackAssetModalClose(id: string, name?: string, language?: string, type?: string) {
  sendEvent({
    event: "Media_Library_Interaction",
    action: "Asset Preview Closed",
    raw_action: "Click",
    section: "Asset Preview Modal",
    name,
    id,
    language,
    type,
  });
}

export function trackShareAsset(section: string, id: string, name?: string, language?: string, type?: string) {
  sendEvent({
    event: "Media_Library_Interaction",
    action: "Asset Shared",
    raw_action: "Click",
    section,
    name,
    id,
    language,
    type,
  });
}
